/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Related_TitleInputs */

const en_blog_related_title = /** @type {(inputs: Blog_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep reading.`)
};

const lv_blog_related_title = /** @type {(inputs: Blog_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turpiniet lasīt.`)
};

/**
* | output |
* | --- |
* | "Keep reading." |
*
* @param {Blog_Related_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_related_title = /** @type {((inputs?: Blog_Related_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Related_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_related_title(inputs)
	return en_blog_related_title(inputs)
});